import React, { useEffect, useState } from 'react'
import { useLocation, useMatch, useParams } from "react-router-dom";
import { AdminPagesService, usePageDetails, useReturnCurrentPageType } from './adminPagesSlice';
import RenderAdminPageContent from './components/RenderAdminPageContent';
import AdminSidebar from './components/Sidebar/AdminSidebar';
import AdminHeader from './components/AdminHeader';
import { RootState } from '../../app/store';
import { useSelector } from 'react-redux';
import { Helmet } from "react-helmet";
import ApplicationConfig from '../../config';

export default function AdminBasePage() {

    const params = useParams()
    const page = AdminPagesService.usePageDetails(params.page_name ? params.page_name : "")
    const type = useReturnCurrentPageType()

    const { smallerSideBar } = useSelector((state: RootState) => state.adminPages)
    const [pageTitle, setPageTitle] = useState<string>(page.title)

    const location = useLocation()

    useEffect(() => {
        
        switch(type){

            case "base":
                setPageTitle(page.title)
                break

            case "new":
                setPageTitle(page.messages.create)
                break

            case "edit":
                setPageTitle(page.messages.edit)
                break

            case "view":
                setPageTitle(page.messages.view)
                break

            default:
                setPageTitle(page.title)
        }

    }, [page, type])

    return(
        <div className="admin-panel-page-main-wrapper">

            <Helmet>
                <title>{pageTitle} - {ApplicationConfig.appName}</title>
            </Helmet>

            <AdminSidebar />
            <AdminHeader />

            <div className={smallerSideBar ? "single-admin-page-side-content full-size" : "single-admin-page-side-content"}>
                <div className="content-of-single-admin-page-side-content">
                    <RenderAdminPageContent key={location.pathname} type={type} page={page} />
                </div>
            </div>

        </div>
    )
}